// Shared frontend surface. The capability constants + catalog are generated
// from capabilities/manifests by tools/capgen — never edit caps.generated.ts by
// hand; run `go run ./tools/capgen` and commit the result (CI drift-checks it).
export * from "./caps.generated";

import { catalog, type Cap } from "./caps.generated";

/**
 * expandImplies returns the granted capabilities plus everything they
 * transitively imply (graded scales: barge ⇒ whisper ⇒ listen ⇒ view). Mirrors
 * the backend caps.ExpandImplies so the UI and server agree.
 */
export function expandImplies(granted: Iterable<string>): Set<string> {
  const impliesByKey = new Map<string, string[]>();
  for (const c of catalog.capabilities) {
    if (c.implies.length) impliesByKey.set(c.key, c.implies);
  }
  const out = new Set<string>();
  const add = (k: string): void => {
    if (out.has(k)) return;
    out.add(k);
    for (const imp of impliesByKey.get(k) ?? []) add(imp);
  };
  for (const k of granted) add(k);
  return out;
}

/** can reports whether the effective set holds a capability. The UI only ever
 * HIDES on this; the server is the authority (caps.Require). */
export function can(effective: Set<string>, cap: Cap | string): boolean {
  return effective.has(cap);
}
